<template>
  <div class="offline-meeting-questionnaire-template" theme>
    <div id="offline-meeting-questionnaire-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-questionnaire-content',
          htmlFile: 'questionnaire'
        }
      ]
    }
  }
}
</script>
